import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location_down",
  "use": "icon-location_down-usage",
  "viewBox": "0 0 16 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 8\" id=\"icon-location_down\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-7-12h30v30H-7z\" /><path fill=\"#999\" d=\"M8 8 .5.5h15z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol